<template>
  <div class="w-full">
    <div class="flex w-full items-center justify-between">
      <div class="px-4" @click="manageMenuMobileClick">
        <IconCloseMenu
          v-if="$modal.getModal('mobileMenu')"
          class="size-6 cursor-pointer"
          data-testid="menu-mobile-close-icon"
        />
        <IconHamburgerMenu
          v-else
          class="size-6 cursor-pointer"
          data-testid="menu-mobile-icon"
        />
      </div>
      <NuxtLink to="/" class="py-3" external no-prefetch>
        <IconBenchmarkLogoMobile />
      </NuxtLink>
      <div
        v-if="!authenticated"
        class="bg-p-100 cursor-pointer text-xs font-semibold py-3 px-4"
        @click="manageSingInClick"
      >
        {{ SIGN_IN }}
      </div>
      <div
        v-else
        class="flex cursor-pointer select-none items-center justify-end py-3 px-4"
        @click="manageMobileAccountClick"
      >
        <IconUser
          class="h-6 w-6"
          :class="[isImpersonating ? 'text-charts-navy-200' : 'text-p-600']"
        />
      </div>
    </div>

    <div>
      <NavigationMobileMenu
        :open="$modal.getModal('mobileMenu')"
        :menu="itemsMenu"
        modal-name="mobileMenu"
      />
      <NavigationMobileMenu
        :open="$modal.getModal('mobileAccountMenu')"
        :menu="ACCOUNT_MENU"
        initial-menu-title="Account"
        modal-name="mobileAccountMenu"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ACCOUNT_MENU, MOBILE_MENU } from '~/constants/main-menu'
import { SIGN_IN } from '~/constants/services/constants'

import { useScreenSize } from '~/composables/useScreenSize'

import useAuthStore from '~/stores/auth'

import NavigationMobileMenu from '~/components/navigation/MobileMenu.vue'
import IconBenchmarkLogoMobile from '~/assets/icons/BenchmarkLogoBlackMobile.svg'
import IconCloseMenu from '~/assets/icons/Close.svg'
import IconHamburgerMenu from '~/assets/icons/Hamburger.svg'
import IconUser from '~/assets/icons/User.svg'

const { $config } = useNuxtApp()
const { $bmAuth, $modal } = useNuxtApp()
const authStore = useAuthStore()
const { isNotDesktop } = useScreenSize()

const authenticated = computed(() => authStore.authenticated)

const itemsMenu = [
  ...MOBILE_MENU,
  {
    name: 'Source',
    href: $config.public.sourceUrl,
    open: false,
    groups: [],
  },
]

const manageMenuMobileClick = () => {
  if ($modal.getModal('mobileMenu')) {
    $modal.close('mobileMenu')
  } else {
    $modal.open('mobileMenu')
    $modal.close('mobileAccountMenu')
  }
}
const manageMobileAccountClick = () => {
  if ($modal.getModal('mobileAccountMenu')) {
    $modal.close('mobileAccountMenu')
  } else {
    $modal.open('mobileAccountMenu')
    $modal.close('mobileMenu')
  }
}
const manageSingInClick = () => {
  if ($modal.getModal('mobileMenu')) {
    $modal.close('mobileMenu')
  }
  $modal.open('signIn')
}

watch(isNotDesktop, (value) => {
  if (!value) {
    $modal.close('mobileMenu')
    $modal.close('mobileAccountMenu')
  }
})

const isImpersonating = computed(() => {
  return $bmAuth.isImpersonating()
})
</script>
